import { queryClient } from '@/lib/react-query';
import {
  UpdateDTO,
  useUpdateMutationFactory,
  UseUpdateMutationProps,
} from '@/lib/react-query/update';
import { WorkOrder } from '@/types';
import { update } from '@/utils/api';
import { featureKeys, featurePath, WorkOrderSearchParams } from '.';

export type UpdateWorkOrderDTO = UpdateDTO<WorkOrder, WorkOrderSearchParams>;

const updateWorkOrder = ({ data, id, params = {} }: UpdateWorkOrderDTO) =>
  update<WorkOrder>(`${featurePath}/${id}`, data, params);

export const useUpdateWorkOrder = (options?: UseUpdateMutationProps<WorkOrder>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: updateWorkOrder,
    onSuccess: (data) => {
      if (data?.taskable_type && data?.taskable_id) {
        queryClient.invalidateQueries({
          queryKey: [{ scope: data.taskable_type, entity: 'detail', id: data.taskable_id }],
        });
      }
    },
    ...options,
  });
};
